// src/components/ProfileDropdown.ts
import "./ProfileDropdown.css";
import { useAuth } from "../context/useAuth";

function getProfileColor(email: string): string {
  const colors = ["#4285f4", "#ea4335", "#fbbc05", "#34a853", "#a142f4"];
  let hash = 0;

  for (let i = 0; i < email.length; i += 1) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
}

export function renderProfileDropdown(
  anchor: HTMLElement,
  onClose: () => void,
) {
  const existing = document.querySelector(".profile-dropdown");
  if (existing) existing.remove();

  const { user } = useAuth();
  const email = user?.email ?? "";
  const shortName = email.split("@")[0] || "User";
  const profileLetter = email[0]?.toUpperCase() ?? "";
  const profileColor = email ? getProfileColor(email) : "#4285f4";

  const dropdown = document.createElement("div");
  dropdown.className = "profile-dropdown";

  dropdown.innerHTML = `
    <div class="pd-top-row">
      <span class="pd-email">${email}</span>
      <button class="pd-close-btn" type="button" aria-label="Close">✕</button>
    </div>

    <div class="pd-profile-section">
      <div class="pd-profile-icon" style="background-color: ${profileColor}">
        ${profileLetter}
        <div class="pd-plus">+</div>
      </div>

      <p class="pd-welcome">Welcome, ${shortName}!</p>

      <button class="pd-manage-btn" type="button">
        Manage your AMailMe Account
      </button>
    </div>

    <details class="pd-more-accounts">
      <summary>Show more accounts</summary>
      <div class="pd-more-content">
        <p class="pd-placeholder">No additional accounts</p>
      </div>
    </details>

    <div class="pd-history-section">
      <div class="pd-history-item">🔍 Search History</div>
      <div class="pd-divider"></div>
      <button class="pd-delete-btn" type="button">
        Delete last 30 minutes
      </button>
    </div>

    <button
      class="pd-browser-download-btn"
      type="button"
    >
      Download AyeSearch Browser
    </button>

    <button class="pd-logout-btn" type="button">
      Log out
    </button>
  `;

  const stopAll = (event: Event) => event.stopPropagation();

  dropdown.addEventListener("mousedown", stopAll);
  dropdown.addEventListener("click", stopAll);
  dropdown.addEventListener("touchstart", stopAll);

  dropdown
    .querySelector(".pd-close-btn")
    ?.addEventListener("click", (event) => {
      event.stopPropagation();
      dropdown.remove();
      onClose();
    });

  dropdown
    .querySelector(".pd-browser-download-btn")
    ?.addEventListener("click", (event) => {
      event.stopPropagation();
      window.location.href = "https://ayesearch.com/downloads/update";
    });

  dropdown
    .querySelector(".pd-logout-btn")
    ?.addEventListener("click", (event) => {
      event.stopPropagation();

      window.location.replace(
        "https://api.ayesearch.com/custom_auth/web/logout/ayesearch/",
      );
    });

  anchor.appendChild(dropdown);
}
